import { render, staticRenderFns } from "./CreateAssignmentButton.vue?vue&type=template&id=02c14874&"
import script from "./CreateAssignmentButton.vue?vue&type=script&lang=ts&"
export * from "./CreateAssignmentButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports